/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react'
import { KTIcon } from '../../../helpers'
import { ChatInner } from '../../chat/ChatInner'
import { useLayout } from '../../../layout/core'
import moment from 'moment'

const DrawerTicketDetail: FC = () => {
  const { currentTicket } = useLayout()

  return (
    <div
      id='kt_drawer_ticket_detail'
      className='bg-body'
      data-kt-drawer='true'
      data-kt-drawer-name='chat'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'300px', 'md': '500px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_drawer_ticket_detail_toggle'
      data-kt-drawer-close='#kt_drawer_ticket_detail_close'
    >
      <div className='card w-100 rounded-0' id='kt_drawer_ticket_detail_messenger'>
        <div className='card-header pe-5' id='kt_drawer_ticket_detail_messenger_header'>
          <div className='card-title'>
            <div className='d-flex justify-content-center flex-column me-3'>
              <h1>Ticket Details</h1>
            </div>
          </div>
          <div className='card-toolbar'>
            <div
              className='btn btn-sm btn-icon btn-active-light-primary'
              id='kt_drawer_ticket_detail_close'
            >
              <KTIcon iconName='cross' className='fs-2' />
            </div>
          </div>
        </div>
        <div className="card-body p-9">
          <div className="row mb-7">
            <label className="col-lg-4 fw-semibold text-muted">Ticket Subject</label>
            <div className="col-lg-8">
              <span className="fw-bold fs-6 text-gray-800">{currentTicket?.subject}</span>
            </div>
          </div>
          <div className="row mb-7">
            <label className="col-lg-4 fw-semibold text-muted">Ticket Description</label>
            <div className="col-lg-8">
              <span className="fw-bold fs-6 text-gray-800">{currentTicket?.message}</span>
            </div>
          </div>
          <div className="row mb-7">
            <label className="col-lg-4 fw-semibold text-muted">Ticket Date</label>
            <div className="col-lg-8">
              <span className="fw-bold fs-6 text-gray-800">{moment(currentTicket?.created_at).format('DD MMM YYYY LT')}</span>
            </div>
          </div>
          <div className="row mb-7">
            <label className="col-lg-4 fw-semibold text-muted">Issuer</label>
            <div className="col-lg-8">
              <span className="fw-bold fs-6 text-gray-800">{currentTicket?.user_email}</span>
            </div>
          </div>
          <div className="row mb-7">
            <label className="col-lg-4 fw-semibold text-muted">Issuer PayAiro Tag</label>
            <div className="col-lg-8">
              <span className="fw-bold fs-6 text-gray-800">{currentTicket?.user_username}</span>
            </div>
          </div>

          <div className="row mb-7">
            <label className="col-lg-4 fw-semibold text-muted">Issuer Mobile No.</label>
            <div className="col-lg-8">
              <span className="fw-bold fs-6 text-gray-800">{currentTicket?.user_mobile_number}</span>
            </div>
          </div>
          <div className="row mb-7">
            <label className="col-lg-4 fw-semibold text-muted">Issuer Type</label>
            <div className="col-lg-8">
              <span className="fw-bold fs-6 text-gray-800">{currentTicket?.user_type}</span>
            </div>
          </div>
          {currentTicket?.attachment && (<div className="row mb-7">
            <label className="col-lg-4 fw-semibold text-muted mb-4">Attachements</label>

            <img src={currentTicket?.attachment} style={{ width: '450px' }} />
          </div>
          )}

        </div>

      </div>


    </div>
  )
}

export { DrawerTicketDetail }
